import * as labels from "config.labels";

export const IS_DEV = process.env.NODE_ENV === "development";

const ROOT_STEM = process.env.REACT_APP_ROOT_STEM;
const MONOLITH_ROOT_STEM = process.env.REACT_APP_MONOLITH_ROOT_STEM;

const ADMIN_STEM = process.env.REACT_APP_ADMIN_STEM;
const AI_AGENTS_STEM = process.env.REACT_APP_AI_AGENTS_STEM;
const ANALYTICS_STEM = process.env.REACT_APP_ANALYTICS_STEM;
const BFF_STEM = process.env.REACT_APP_BFF_STEM;
const CLAIMS_STEM = process.env.REACT_APP_CLAIMS_STEM;
const DOC_GEN_STEM = process.env.REACT_APP_DOC_GEN_STEM;
const EMAIL_STEM = process.env.REACT_APP_EMAIL_STEM;
const EXCHANGE_STEM = process.env.REACT_APP_EXCHANGE_STEM;
const EXCHANGE_PROXY_STEM = process.env.REACT_APP_EXCHANGE_PROXY_STEM;
const FILES_STEM = process.env.REACT_APP_FILES_STEM;
const INGEST_STEM = process.env.REACT_APP_INGEST_STEM;
const MAPPING_SUGGESTIONS_STEM = process.env.REACT_APP_MAPPING_SUGGESTIONS_STEM;
const MATERIALIZE_STEM = process.env.REACT_APP_MATERIALIZE_STEM;
const NOTES_STEM = process.env.REACT_APP_NOTES_STEM;
const RESEARCH_STEM = process.env.REACT_APP_RESEARCH_STEM;
const PERSISTENCE_STEM = process.env.REACT_APP_PERSISTENCE_STEM;
const REPORTS_V2_STEM = process.env.REACT_APP_REPORTS_V2_STEM;
const REPORTS_V3_STEM = process.env.REACT_APP_REPORTS_V3_STEM;
const SELECTORS_STEM = process.env.REACT_APP_SELECTORS_STEM;
const SOV_STEM = process.env.REACT_APP_SOV_STEM;
const STATIC_DATA_STEM = process.env.REACT_APP_STATIC_DATA_STEM;
const TABLES_STEM = process.env.REACT_APP_TABLES_STEM;
const TRANSFER_STEM = process.env.REACT_APP_TRANSFER_STEM;
const USER_STEM = process.env.REACT_APP_USER_STEM;

export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || "dev";

const sanitizePath = (path) => {
  if (path == null || typeof path !== "string") return "";
  return path.startsWith("/") ? path.substring(1) : path;
};

const urlAppendingPath = (baseUrl, path) => {
  if (!baseUrl && process.env.NODE_ENV !== "test") {
    throw new Error("Must specify a URL stem.");
  }
  return baseUrl + sanitizePath(path);
};

export const endpoints = {
  root: (path) => {
    try {
      const featureFlags = JSON.parse(
        localStorage.getItem("MMM.featureFlags") ?? "{}"
      );
      const service = path.replace("/", "");
      const stem = featureFlags[`use-monolith/${service}`]
        ? MONOLITH_ROOT_STEM
        : ROOT_STEM;
      return urlAppendingPath(stem, path);
    } catch (e) {
      return urlAppendingPath(ROOT_STEM, path);
    }
  },
  admin: (path) =>
    urlAppendingPath(ADMIN_STEM || endpoints.root("admin/"), path),
  aiAgents: (path) =>
    urlAppendingPath(AI_AGENTS_STEM || endpoints.root("ai-agents/"), path),
  analytics: (path) =>
    urlAppendingPath(ANALYTICS_STEM || endpoints.root("analytics/"), path),
  bff: (path) => urlAppendingPath(BFF_STEM || endpoints.root("bff/"), path),
  claims: (path) =>
    urlAppendingPath(CLAIMS_STEM || endpoints.root("claims/"), path),
  docGen: (path) =>
    urlAppendingPath(DOC_GEN_STEM || endpoints.root("doc-gen/"), path),
  email: (path) =>
    urlAppendingPath(EMAIL_STEM || endpoints.root("email/"), path),
  exchange: (path) =>
    urlAppendingPath(EXCHANGE_STEM || endpoints.root("exchange/"), path),
  exchangeProxy: (path) =>
    urlAppendingPath(
      EXCHANGE_PROXY_STEM || endpoints.root("exchange-proxy/"),
      path
    ),
  files: (path) =>
    urlAppendingPath(FILES_STEM || endpoints.root("files/"), path),
  ingest: (path) =>
    urlAppendingPath(INGEST_STEM || endpoints.root("ingest/"), path),
  mappingSuggestions: (path) =>
    urlAppendingPath(
      MAPPING_SUGGESTIONS_STEM || endpoints.root("suggest-column-mappings/"),
      path
    ),
  materialize: (path) =>
    urlAppendingPath(MATERIALIZE_STEM || endpoints.root("materialize/"), path),
  notes: (path) =>
    urlAppendingPath(NOTES_STEM || endpoints.root("notes/"), path),
  research: (path) =>
    urlAppendingPath(RESEARCH_STEM || endpoints.root("research/"), path),
  persistence: (path) =>
    urlAppendingPath(PERSISTENCE_STEM || endpoints.root("submissions/"), path),
  reports: (path) =>
    urlAppendingPath(REPORTS_V2_STEM || endpoints.root("reports-v2/"), path),
  reportsV3: (path) =>
    urlAppendingPath(REPORTS_V3_STEM || endpoints.root("reports/v3/"), path),
  selectors: (path) =>
    urlAppendingPath(SELECTORS_STEM || endpoints.root("selectors/"), path),
  sov: (path) => urlAppendingPath(SOV_STEM || endpoints.root("sov/"), path),
  staticData: (path) =>
    urlAppendingPath(STATIC_DATA_STEM || endpoints.root("static-data/"), path),
  tables: (path) =>
    urlAppendingPath(TABLES_STEM || endpoints.root("tables/"), path),
  transfer: (path) =>
    urlAppendingPath(TRANSFER_STEM || endpoints.root("transfer/"), path),
  user: (path) => urlAppendingPath(USER_STEM || endpoints.root("user/"), path),
};

const OPEN_REPLAY_PROJECT_ID = process.env.REACT_APP_OPEN_REPLAY_PROJECT_ID;
const OPEN_REPLAY_DISABLE_SECURE_MODE =
  process.env.REACT_APP_OPEN_REPLAY_DISABLE_SECURE_MODE || false;

export const getOpenReplayProjectId = () => OPEN_REPLAY_PROJECT_ID;
export const getOpenReplayDisableSecureMode = () =>
  OPEN_REPLAY_DISABLE_SECURE_MODE;

export const HEAP_APP_ID = process.env.REACT_APP_HEAP_APP_ID;

const MAINTENANCE_CONTROL_URL = process.env.REACT_APP_MAINTENANCE_CONTROL_URL;
const TOKEN_PRE_EXPIRY_REFRESH_SECONDS =
  process.env.REACT_APP_TOKEN_PRE_EXPIRY_REFRESH_SECONDS;

export const PURE_BURN_COST_KEY = "PURE_BURN_COST";
export const ILF_FROM_BASE_KEY = "SCALED_BASE_LAYER";
export const PURE_MODEL = "PURE_MODEL";
export const SCALED_EXPERIENCE = "SCALED_EXPERIENCE";
export const RECOMMENDED_BLEND = "RECOMMENDED_BLEND";
export const UW_ADJUSTED = "UW_ADJUSTED";

export const LOSS_TYPE_KEY = "_COVERAGE";
export const OPEN_CLOSED = "_OPEN_CLOSED";
export const EXCLUDE_KEY = "_EXCLUDE";

export const CURRENT_FILE_SCHEMA_VERSION = 34;

export const NAICS_SEEKER = {
  endpointStem: endpoints.claims(),
  endpoint: "pricing/naics/query",
  key: "PRICING_NAICS",
};

export const CATEGORY_CODE_SEEKER = {
  endpointStem: endpoints.claims(),
  endpoint: "pricing/classifications/query",
  key: "CODE_CATEGORY",
};

export const COMPANY_NAICS_SEEKER = {
  endpointStem: endpoints.claims(),
  endpoint: "pricing/naics/query",
  key: "COMPANY_NAICS",
};

export const PEER_NAICS_SEEKER = {
  endpointStem: endpoints.claims(),
  endpoint: "pricing/naics/query",
  key: "PEER_NAICS",
};

export const INDUSTRY_CLASS_SEEKER = {
  endpointStem: endpoints.claims(),
  endpoint: "exposure/industry-classes",
  key: "EXPOSURE_INDUSTRY_CLASSES",
};

export const PEER_SEEKER = {
  endpointStem: endpoints.persistence(),
  endpoint: "query",
  key: "PEER",
};

export const PRIOR_SUBMISSION = {
  endpointStem: endpoints.persistence(),
  endpoint: "query",
  key: "PRIOR_SUBMISSION",
};

export const DEFINITION_GNULR =
  "Expected Loss Cost / 100% Premium after Brokerage and Other Acquisition Costs are deducted.";
export const DEFINITION_TP =
  "Gross Premium less required Profit and Expenses / Expected Loss Cost with a loading for Brokerage and Other Acquisition costs.";
export const DEFINITION_TAC =
  "The Total Acquisition Costs: Sum of Brokerage and Other Acquisition Costs";
export const DEFINITION_IN_FORCE =
  "The date chosen such that all policies with an inception before it and an expiration after it will be selected.";

export const BUDGET_ACQUISITION_RATIO = 0.075;
export const BUDGET_GROSS_LOSS_RATIO = 0.68;
export const BUDGET_TECHNICAL_RATIO = 0.755;
export const PERMISSABLE_TECHNICAL_RATIO = 0.918994;
export const TARGET_TECHNICAL_RATIO = 0.858534;

export const TURNOVERS = [
  {
    key: "A",
    value: "Small - Below $5b",
  },
  {
    key: "B",
    value: "Medium - Between $5b and $10b",
  },
  {
    key: "C",
    value: "Large - Between $10b and $20b",
  },
  {
    key: "D",
    value: "Extra Large - Between $20b and $30b",
  },
  {
    key: "E",
    value: "Extra Extra Large - Over $30b",
  },
];

export const SCENARIOS = [
  {
    name: "Legacy Scenarios",
    items: [
      {
        id: "PPI",
        label: "Financial Product Mis-selling UK",
        tip:
          "This event arises from the systemic mis-selling by banks of a financial product sold within the UK. Although this event does not reflect a single historical or emerging event, the event is similar to Ponzi schemes such as the global Madoff and Stanford schemes, PPI mis-selling in the UK and a possible pension mis-selling event in the UK.",
      },
      {
        id: "INSIDER_TRADING",
        label: "Financial Market Manipulation US",
        tip:
          "This event arises from systemic misrepresentations in prospectuses or market / rate manipulations or other systemic unlawful or misleading banking practices in the US. Although this event does not reflect a single historical event, the event is similar to the IPO laddering market manipulation in the US during the late 1990’s, and the global Forex and LIBOR rigging events.",
      },
      {
        id: "OPIOD",
        label: "Pharmaceutical Product US",
        tip:
          "This event arises from a systemic failure by multiple pharmaceutical manufacturers to warn consumers of a significant harm from a generic drug or class of prescription drugs widely used for many years in the US. Although this event does not reflect a single historical or emerging event, the event is similar to the opioid crisis in the US, or a potential event from a generic drug such as paracetamol.",
      },
      {
        id: "CONSTRUCTION",
        label: "Construction Product Global",
        tip:
          "This is a global event arising from a latent design defect related to widely used construction products which results in the repair or rebuild of a few thousand residential structures. Although this event does not reflect a single historical or emerging event, the event is similar to the global issue with potentially flammable siding (cladding) such as Aluminium Composite Materials (ACM) and High-Pressure Laminates (HPL), or a possible issue such as mass timber.",
      },
      {
        id: "POISON",
        label: "Chemicals in Food US",
        tip:
          "This event arises from an agrochemical or other additive / dye used for decades in the US which is widely present in food and proven to cause significant bodily harm. Although this event does not reflect a single historical or emerging event, the event is similar to events involving potentially harmful agrochemicals such as DDT or glyphosates.",
      },
      {
        id: "ENERGY",
        label: "Offshore / Onshore Energy US",
        tip:
          "This event arises from a fire and subsequent boil-over at a US onshore fuel storage facility which provides a vital source of crude oil into a large proportion of the UW' refining capabilities. Although this is a synthetic event and does not reflect any historical event, previous fire and boil-overs include the 2019 Storage Tank Fire at Intercontinental Terminals in Texas and 1983 Milford Haven event in Wales.",
      },
    ],
  },
];

export const POLICY_FORMS = [
  {
    code: "AEGIS",
    name: "AEGIS",
  },
  {
    code: "BSF_CM",
    name: "BSF CM",
  },
  {
    code: "BSF_OCC",
    name: "BSF Occ",
  },
  {
    code: "CLAIMS_MADE",
    name: "Claims Made",
  },
  {
    code: "MXS_CM",
    name: "MXS CM",
  },
  {
    code: "MXS_OCC",
    name: "MXS Occ",
  },
  {
    code: "OCC01",
    name: "OCC01",
  },
  {
    code: "XS02",
    name: "XS02",
  },
  {
    code: "XS02_RI",
    name: "XS02 RI",
  },
  {
    code: "XS004",
    name: "XS004",
  },
  {
    code: "XS004_RI",
    name: "XS004 RI",
  },
  {
    code: "XS005",
    name: "XS005",
  },
  {
    code: "XS005_RI",
    name: "XS005 RI",
  },
  {
    code: "FAC_RI",
    name: "Fac RI",
  },
];

export const US_STATE_NAMES = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District Of Columbia",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};

export const GRID_SPACING = 2;
export const SELECTED_ROW_BACKGROUND_COLOR = "#dbdce5";
export const FETCHING_OPACITY = 0.5;

export const MAINTENANCE_STATE_POLL_INTERVAL_SECS = 60;
export const MAINTENANCE_STATE_ERROR_RETRY_TIME_SECS = 5;
export const getMaintenanceControlUrl = () => MAINTENANCE_CONTROL_URL;

export const getTokenPreExpiryRefreshSeconds = () =>
  parseInt(TOKEN_PRE_EXPIRY_REFRESH_SECONDS || "900");

const JOIN_NAME_PREFIX = "JOIN ";
export const getJoinNamePrefix = () => JOIN_NAME_PREFIX;

const REPORT_SOURCE_PREFIX = "REPORT:";
export const getReportSourcePrefix = () => REPORT_SOURCE_PREFIX;

const REPORTS_V3_DYNAMIC_DATE_RANGE_FUNCTION = "DYNAMIC_DATE_RANGE";
export const reportsV3DynamicDateRangeFunction = () =>
  REPORTS_V3_DYNAMIC_DATE_RANGE_FUNCTION;

const REPORTS_V3_DYNAMIC_DATE_PRESETS = [
  {
    key: "DYN_LAST_7",
    group: "LAST",
    labelKey: labels.REPORTS_V3_DYNAMIC_DATE_LAST_7,
    defaultLabel: "Last 7 days",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_7_DAYS,
    chipDefaultLabel: "7 days",
    parameters: ["today -6 days", "today LTE"],
  },
  {
    key: "DYN_LAST_30",
    group: "LAST",
    labelKey: labels.REPORTS_V3_DYNAMIC_DATE_LAST_30,
    defaultLabel: "Last 30 days",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_30_DAYS,
    chipDefaultLabel: "30 days",
    parameters: ["today -29 days", "today LTE"],
  },
  {
    key: "DYN_LAST_90",
    group: "LAST",
    labelKey: labels.REPORTS_V3_DYNAMIC_DATE_LAST_90,
    defaultLabel: "Last 90 days",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_90_DAYS,
    chipDefaultLabel: "90 days",
    parameters: ["today -89 days", "today LTE"],
  },
  {
    key: "DYN_LAST_WEEK",
    group: "LAST",
    labelKey: labels.REPORTS_V3_DYNAMIC_DATE_LAST_WEEK,
    defaultLabel: "Last week",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_WEEK,
    chipDefaultLabel: "week",
    parameters: ["week_start -7 day", "week_start"],
  },
  {
    key: "DYN_LAST_MONTH",
    group: "LAST",
    labelKey: labels.REPORTS_V3_DYNAMIC_DATE_LAST_MONTH,
    defaultLabel: "Last month",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_MONTH,
    chipDefaultLabel: "month",
    parameters: ["month_start -1 month", "month_start"],
  },
  {
    key: "DYN_LAST_QTR",
    group: "LAST",
    labelKey: labels.REPORTS_V3_DYNAMIC_DATE_LAST_QTR,
    defaultLabel: "Last quarter",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_QUARTER,
    chipDefaultLabel: "quarter",
    parameters: ["quarter_start -3 months", "quarter_start"],
  },
  {
    key: "DYN_LAST_YEAR",
    group: "LAST",
    labelKey: labels.REPORTS_V3_DYNAMIC_DATE_LAST_YEAR,
    defaultLabel: "Last year",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_YEAR,
    chipDefaultLabel: "year",
    parameters: ["year_start -1 year", "year_start"],
  },
  {
    key: "DYN_THIS_WEEK",
    group: "THIS",
    labelKey: labels.REPORTS_V3_DYNAMIC_DATE_THIS_WEEK,
    defaultLabel: "This week",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_WEEK,
    chipDefaultLabel: "week",
    parameters: ["week_start", "week_start +7 day"],
  },
  {
    key: "DYN_THIS_MONTH",
    group: "THIS",
    labelKey: labels.REPORTS_V3_DYNAMIC_DATE_THIS_MONTH,
    defaultLabel: "This month",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_MONTH,
    chipDefaultLabel: "month",
    parameters: ["month_start", "month_start +1 month"],
  },
  {
    key: "DYN_THIS_QTR",
    group: "THIS",
    labelKey: labels.REPORTS_V3_DYNAMIC_DATE_THIS_QTR,
    defaultLabel: "This quarter",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_QUARTER,
    chipDefaultLabel: "quarter",
    parameters: ["quarter_start", "quarter_start +3 months"],
  },
  {
    key: "DYN_THIS_YEAR",
    group: "THIS",
    labelKey: labels.REPORTS_V3_DYNAMIC_DATE_THIS_YEAR,
    defaultLabel: "This year",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_YEAR,
    chipDefaultLabel: "year",
    parameters: ["year_start", "year_start +1 year"],
  },
  {
    key: "DYN_NEXT_7",
    group: "NEXT",
    labelKey: labels.REPORTS_V3_DYNAMIC_DATE_NEXT_7,
    defaultLabel: "Next 7 days",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_7_DAYS,
    chipDefaultLabel: "7 days",
    parameters: ["today", "today +7 day"],
  },
  {
    key: "DYN_NEXT_30",
    group: "NEXT",
    labelKey: labels.REPORTS_V3_DYNAMIC_DATE_NEXT_30,
    defaultLabel: "Next 30 days",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_30_DAYS,
    chipDefaultLabel: "30 days",
    parameters: ["today", "today +30 day"],
  },
  {
    key: "DYN_NEXT_90",
    group: "NEXT",
    labelKey: labels.REPORTS_V3_DYNAMIC_DATE_NEXT_90,
    defaultLabel: "Next 90 days",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_90_DAYS,
    chipDefaultLabel: "90 days",
    parameters: ["today", "today +90 day"],
  },
  {
    key: "DYN_NEXT_WEEK",
    group: "NEXT",
    labelKey: labels.REPORTS_V3_DYNAMIC_DATE_NEXT_WEEK,
    defaultLabel: "Next week",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_WEEK,
    chipDefaultLabel: "week",
    parameters: ["week_start +7 days", "week_start +14 days"],
  },
  {
    key: "DYN_NEXT_MONTH",
    group: "NEXT",
    labelKey: labels.REPORTS_V3_DYNAMIC_DATE_NEXT_MONTH,
    defaultLabel: "Next month",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_MONTH,
    chipDefaultLabel: "month",
    parameters: ["month_start +1 month", "month_start +2 months"],
  },
  {
    key: "DYN_NEXT_QTR",
    group: "NEXT",
    labelKey: labels.REPORTS_V3_DYNAMIC_DATE_NEXT_QTR,
    defaultLabel: "Next quarter",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_QUARTER,
    chipDefaultLabel: "quarter",
    parameters: ["quarter_start +3 months", "quarter_start +6 months"],
  },
  {
    key: "DYN_MTD",
    group: "TO_DATE",
    labelKey: labels.REPORTS_V3_DYNAMIC_DATE_MTD,
    defaultLabel: "Month to date",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_MONTH,
    chipDefaultLabel: "month",
    parameters: ["month_start", "today LTE"],
  },
  {
    key: "DYN_YTD",
    group: "TO_DATE",
    labelKey: labels.REPORTS_V3_DYNAMIC_DATE_YTD,
    defaultLabel: "Year to date",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_YEAR,
    chipDefaultLabel: "year",
    parameters: ["year_start", "today LTE"],
  },
];
const REPORTS_V3_DYNAMIC_DATE_PRESET_GROUPS = {
  LAST: "LAST",
  THIS: "THIS",
  NEXT: "NEXT",
  TO_DATE: "TO_DATE",
};
export const reportsV3DynamicDatePresetGroups = () => ({
  ...REPORTS_V3_DYNAMIC_DATE_PRESET_GROUPS,
});

export const reportsV3DatePresetIndentPx = () => 15;

// Wide enough for the date filter's From and To inputs side by side.
export const reportsV3FilterPanelWidthPx = () => 400;

export const reportsV3DynamicDatePresets = () =>
  REPORTS_V3_DYNAMIC_DATE_PRESETS.map((preset) => ({
    ...preset,
    parameters: [...preset.parameters],
  }));

// The fixed (static) presets, keyed as in utils/dateUtils DATE_PRESET_KEYS.
const REPORTS_V3_STATIC_DATE_PRESETS = [
  {
    key: "LAST_7",
    group: "LAST",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_7_DAYS,
    chipDefaultLabel: "7 days",
  },
  {
    key: "LAST_30",
    group: "LAST",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_30_DAYS,
    chipDefaultLabel: "30 days",
  },
  {
    key: "LAST_90",
    group: "LAST",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_90_DAYS,
    chipDefaultLabel: "90 days",
  },
  {
    key: "LAST_WEEK",
    group: "LAST",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_WEEK,
    chipDefaultLabel: "week",
  },
  {
    key: "LAST_MONTH",
    group: "LAST",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_MONTH,
    chipDefaultLabel: "month",
  },
  {
    key: "LAST_QTR",
    group: "LAST",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_QUARTER,
    chipDefaultLabel: "quarter",
  },
  {
    key: "LAST_YEAR",
    group: "LAST",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_YEAR,
    chipDefaultLabel: "year",
  },
  {
    key: "MTD",
    group: "TO_DATE",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_MONTH,
    chipDefaultLabel: "month",
  },
  {
    key: "YTD",
    group: "TO_DATE",
    chipLabelKey: labels.REPORTS_V3_DATE_FILTER_CHIP_YEAR,
    chipDefaultLabel: "year",
  },
];
export const reportsV3StaticDatePresets = () =>
  REPORTS_V3_STATIC_DATE_PRESETS.map((preset) => ({ ...preset }));

const DUPLICATE_SOURCE_PREFIX = "\u2191 ";
export const getDuplicateSourcePrefix = () => DUPLICATE_SOURCE_PREFIX;

const COLUMN_SOURCE_SEPARATOR = " - ";
export const getColumnSourceSeparator = () => COLUMN_SOURCE_SEPARATOR;

export const SUPPORT_EMAIL = "support@cactus.bm";

export const CLAIMS_MAPPING_IGNORE_VALUE = "[IGNORE]";
export const CLAIMS_MAPPING_INCLUDE_VALUE = "[INCLUDE]";

const readAwsExports = () => {
  try {
    return require("./aws-exports.js").default;
  } catch {
    return {};
  }
};

const awsExports = readAwsExports();

export const COGNITO_USER_POOL_ID =
  process.env.REACT_APP_COGNITO_USER_POOL_ID ?? awsExports.aws_user_pools_id;
export const COGNITO_USER_POOL_CLIENT_ID =
  process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID ??
  awsExports.aws_user_pools_web_client_id;

export const DISABLE_COGNITO_HOSTED_UI =
  process.env.REACT_APP_DISABLE_COGNITO_HOSTED_UI === "true";

export const FEATURE_FLAG_POLLING_INTERVAL_MS = isFinite(
  parseInt(process.env.REACT_APP_FEATURE_FLAG_POLLING_INTERVAL_MS)
)
  ? parseInt(process.env.REACT_APP_FEATURE_FLAG_POLLING_INTERVAL_MS)
  : 60_000;
